import { createJungleChakraTheme } from "../../chakraTheme";

// The app's Chakra theme with the marketing site's text font as the default: the marketing site does not
// load the app's Outfit font, and every marketing page sets Nunito Sans through the landing theme anyway.
// The marketing site is always light: `false` leaves out the rules only a dark learner page uses.
export const marketingSiteChakraTheme = createJungleChakraTheme({ body: '"Nunito Sans", sans-serif' }, "light", false);
